import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

/**
 * Hook to access app store data (business info, config, etc.).
 *
 * IMPORTANT: Components using this hook must be wrapped with MobX `observer()`
 * to react to observable changes.
 */
export function useApp() {
  const stores = useContext(MobXProviderContext) as Record<string, any>;

  if (!stores?.appStore) {
    throw new Error('useApp must be used within a MobX Provider');
  }

  const store = stores.appStore;
  const business = store.business;

  const baseUrl = business?.NativeHomeUrlWithLanguage ?? '';

  return {
    store,
    logoUrl: baseUrl ? `${baseUrl}/business/getlogo?h=144&mode=pad` : '',
    businessName: (business?.Name as string) ?? '',
    resourceImageBaseUrl: baseUrl,
  };
}
